import React, { useEffect } from "react";
import { connect } from "react-redux";
import english from "./../private/english.json";
import arabic from "./../private/arabic.json";

let language = localStorage.getItem("language");

const I18n = ({ lng, user }) => {
  let getlng = lng ? lng.split(".") : [];

  // const [language, setLanguage] = useState("ENGLISH");
  // const userLanguage = user?.language;
  // const localStorageLanguage = localStorage.getItem("language");

  // useEffect(() => {
  //   if (userLanguage) {
  //     setLanguage(userLanguage);
  //   } else if (localStorageLanguage) {
  //     setLanguage(localStorageLanguage);
  //   }
  // }, [userLanguage, localStorageLanguage]);

  useEffect(() => {
    language = user?.language
      ? user.language
      : localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "ENGLISH";
  }, [lng, user]);

  return language === "ENGLISH" || !language
    ? english?.[getlng[0]]?.[getlng[1]] || "Default text"
    : arabic?.[getlng[0]]?.[getlng[1]] || "النص الافتراضي";
};

const mapStateToProps = ({ authentication }) => ({
  user: authentication.user,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(I18n);

export const i18n = (lng) => {
  let getlng = lng ? lng.split(".") : [];
  return language === "ENGLISH" || !language
    ? english?.[getlng[0]]?.[getlng[1]] || "Default text"
    : arabic?.[getlng[0]]?.[getlng[1]] || "النص الافتراضي";
};
